import { format } from 'date-fns';
import FormTableCalculateDisplay from '../../../components/form-table-calculate/form-table-calculate.component';
import FormTableHeaderCell from '../../../components/form-table-header-cell/form-table-header-cell.component';
import FormTableInlineDelete from '../../../components/form-table-inline-delete/form-table-inline-delete.component';
import FormTableSelect from '../../../components/form-table-select/form-table-select.component';
import FormTableTextField from '../../../components/form-table-text-field/form-table-text-field.component';

export const EXPENSE_TYPE_INFO = {
  formTitle: "Expense Type",
  formTitleForNew: "New Expense Type",
  path: "/expensetypes",
  listPage: "/expense-types"
}

export const EXPENSE_TYPE_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 1,
      fieldName: "expenseType",
      fieldItems: [
        {
          label: "Expense Type Name",
          type: "text",
          name: "expenseTypeName",
          initialFocus: false,
          validationProps: {
            required: "Expense Type Name is required"
          }
        },
        {
          label: "Description",
          type: "text",
          name: "description",
          initialFocus: false
        }
      ]
    }
  },
  watchFields: []
}
